<template>
	<ImageSelector :showRemove="Boolean(avatarSrc)" @onFileSelected="$emit('onFileSelected')" />
</template>

<script>
import ImageSelector from '@/components/Settings/ImageSelector.vue';
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service';

export default {
	name: 'AvatarSelector',
	components: { ImageSelector },
	props: {
		user: { type: Object },
	},
	computed: {
		avatarSrc() {
			return AppAvatarService.getAvatarSrc(this.user.profile);
		},
	},
};
</script>
